import { IonSkeletonText } from '@ionic/react'
import React from 'react'

interface Props {
	color: string
	text: string
	value: string
	loading: boolean
}

const TooltipElement = ({ color, text, value, loading }: Props) => {
	const split = value.split(' ')

	return (
		<div
			className='element bg-white text-text-dark dark:bg-background-200-dark dark:text-white'
			style={{ border: `1px solid ${color}` }}
		>
			{<span className='title'>{text}</span>}
			<div className={`container ${loading ? 'loading' : ''} whitespace-nowrap tabular-nums`}>
				{loading ? (
					<IonSkeletonText animated style={{ width: '35%', margin: 0 }} />
				) : (
					<span className='value tracking-wide'>{split[0] + ' '}</span>
				)}
			</div>
			<span className='unit tracking-wide'>{split[1]}</span>
		</div>
	)
}

export default TooltipElement
